import { toast } from "react-toastify";
import { postApiCall } from "../Handlers/HttpHandler";

export const getGamesReportFilters = async(token) => {
    try {
        var filters = await postApiCall("reports/getGamesReportFilters", null, token);

        if (filters.data !== null) {
            return filters.data;
        } else {
            toast.error(filters.error);
            return null;
        }
    } catch (ex) {
        toast.error(ex);
        return null;
    }
}

export const getGameReport = async(token, body) => {
    try {
        var report = await postApiCall("reports/getGamesReport", body, token);
        if (report.data !== null) {
            return report.data;
        } else {
            toast.error(report.error);
            return null;
        }
    } catch (ex) {
        toast.error(ex);
        return null;
    }
}